<template>
  <div class="detacon">
    <van-nav-bar
      :title="$t('m.lc_span0')"
      @click-left="fanhui"
      left-arrow
    ></van-nav-bar>

    <div class="productSort_con_list">
      <div style="padding: 0 10px">
        <div
          class="productSort_block"
          style="border-radius: 8px; margin-top: 46px"
        >
          <div class="productSort_block_left">
            <p class="productSort_block_left_xh">{{ dicdata.title }}</p>
          </div>
          <div class="productSort_block_last">
            <div class="productSort_block_last_item" style="width: 50%">
              <p
                class=""
                style="
                  font-size: 20px;
                  font-weight: bold;
                  color: var(--bg-color);
                  margin-bottom: 6px;
                  height: 30px;
                  line-height: 30px;
                "
              >
                {{ dicdata.rate }}%
              </p>
              <p class="" style="font-size: 12px; color: #999">
                {{ $t("m.rishouyi") }}
              </p>
            </div>
            <div class="productSort_block_last_item" style="width: 50%">
              <p
                class=""
                style="
                  font-size: 15px;
                  color: var(--bg-color);
                  margin-bottom: 6px;
                  height: 30px;
                  line-height: 30px;
                "
              >
                <span style="font-size: 12px; margin-right: 10px; color: #999"
                  >投资周期</span
                >
                <span style="font-weight: bold"
                  >{{ dicdata.day }}{{ $t("m.lc_span23") }}</span
                >
              </p>
              <p
                class=""
                style="
                  font-size: 15px;
                  color: var(--bg-color);
                  height: 30px;
                  line-height: 30px;
                "
              >
                <span style="font-size: 12px; margin-right: 10px; color: #999"
                  >剩余金额</span
                >
                <span style="font-weight: bold">{{ shengxia }}</span>
              </p>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; padding: 9px"
            class="fengxian1"
          >
            <span>{{ dicdata.tag }}</span>
            <span>{{ $t("m.lc_span24") }}</span>
            <span v-show="dicdata.added > 0">增值收益</span>
            <span>{{ dicdata.min }}{{ $t("m.qitou") }}</span>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 20px;
              padding: 0 9px;
            "
          >
            <span style="color: #999; width: 60px; font-size: 12px"
              >{{ $t("m.lc_span28") }}：</span
            >
            <div
              style="
                width: 60%;
                height: 6px;
                background-color: #f3f0f6;
                border-radius: 6px;
              "
            >
              <div
                style="
                  background-color: var(--bg-color);
                  height: 100%;
                  border-radius: 6px;
                "
                :style="{ width: dicdata.schedule + '%' }"
              ></div>
            </div>
            <span style="font-size: 12px; color: #666; margin-left: 10px"
              >{{ dicdata.schedule }}%</span
            >
          </div>
        </div>
      </div>

      <div style="padding: 0">
        <van-tabs swipeable animated>
          <van-tab :label="$t('m.hz_span19')" title="产品详情">
            <div style="padding: 0 10px">
              <div class="detacon_quxian" style="margin-top: 10px">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.zx_span1") }}</span>
                  <span style="color: #000; max-width: 200px"
                    >{{ dicdata.tag }}{{ dicdata.title }}</span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.lc_span1") }}</span>
                  <span style="color: #000">{{ dicdata.schedule }}%</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.lc_span2") }}</span>
                  <span style="color: #000">{{ dicdata.price }}</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">剩余金额</span>
                  <span style="color: #000">{{ shengxia }}</span>
                </div>
                <template v-if="dicdata.added > 0">
                  <div
                    style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                  >
                    <span style="color: #666">增值收益</span>
                    <span style="color: #000">{{ dicdata.added }}%</span>
                  </div>

                  <div
                    style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                  >
                    <span style="color: #666">红包收益</span>
                    <span style="color: #000">{{ dicdata.gift }}%</span>
                  </div>

                  <div
                    style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                  >
                    <span style="color: #666">VIP加息</span>
                    <span style="color: #000">{{ dicdata.vip_rate }}%</span>
                  </div>
                </template>

                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.rishouyi") }}</span>
                  <span style="color: #000">{{ dicdata.rate }}%</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.lc_span3") }}</span>
                  <span style="color: #000">限投{{ dicdata.mcount }}次</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.lc_span4") }}</span>
                  <span style="color: #000">无限制</span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <span style="color: #666">{{ $t("m.lc_span5") }}</span>
                  <span style="color: #000" v-if="dicdata.company">{{
                    dicdata.company.name
                  }}</span>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab :label="$t('m.hz_span24')" title="收益计算">
            <div style="padding: 0 10px">
              <div class="detacon_quxian" style="margin-top: 10px">
                <p style="text-align: left" class="">{{ $t("m.lc_span6") }}</p>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="
                      background: var(--bg-color);
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      position: relative;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        top: 18px;
                        left: 0;
                        width: 70px;
                        color: #666;
                        text-align: left;
                        font-size: 10px;
                      "
                    >
                      <span style="display: block; color: #000">
                        {{ $t("m.lc_span7") }}
                      </span>
                      <span style="color: #666">{{ $t("m.lc_span10") }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      height: 2px;
                      background-color: var(--bg-color);
                    "
                  ></div>
                  <div
                    style="
                      background: var(--bg-color);
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      position: relative;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        top: 18px;
                        left: -31px;
                        width: 70px;
                        color: #666;
                        text-align: center;
                        font-size: 10px;
                      "
                    >
                      <span style="display: block; color: #000">{{
                        $t("m.lc_span8")
                      }}</span>
                      <span style="color: #666">{{ $t("m.lc_span11") }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      height: 2px;
                      background-color: var(--bg-color);
                      position: relative;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        top: 14px;
                        right: -16px;
                        width: 90px;
                        color: #666;
                        text-align: right;
                        font-size: 10px;
                      "
                    >
                      <span style="display: block; color: #000">{{
                        $t("m.lc_span9")
                      }}</span>
                      <span style="color: #666">{{ $t("m.lc_span12") }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      background: var(--bg-color);
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      position: relative;
                    "
                  ></div>
                </div>
                <div
                  style="
                    margin-top: 60px;
                    font-size: 15px;
                    color: #000;
                    width: 100%;
                    line-height: 30px;
                  "
                >
                  <!--                  {{ dicdata.min }}*{{ dicdata.rate }}%*-->
                  <!--                  {{ dicdata.day }}-->
                  <!--                  {{ guo > 0 ? "+" + guo : ""}}-->
                  <!--                  {{ hong > 0 ? "+" + hong : "" }}={{ zhi }}-->
                </div>
                <div
                  class="desc-sll"
                  style="margin-top:60px;font-size:15px;color:#000;width: 100%;line-height:30px;"
                >
                  <p>
                    1.CNY收益：{{ dicdata.min }}*{{
                      (
                        parseFloat(dicdata.rate) + parseFloat(dicdata.vip_rate)
                      ).toFixed(2)
                    }}%*{{ dicdata.day }}{{ jguo > 0 ? "+" + jguo : ""
                    }}{{ jhong > 0 ? "+" + jhong : "" }}={{ jzhi.toFixed(2) }}
                    CNY
                  </p>
                  <p>2.按天付收益，到期平仓</p>
                  <p>3.持仓期：{{ dicdata.day }} 天</p>
                  <p>
                    4.收益计算：以建仓{{ dicdata.min }} CNY计算，持仓金额{{
                      dicdata.min
                    }}
                    CNY*日化回报率{{
                      (
                        parseFloat(dicdata.rate) +
                        (parseFloat(dicdata.vip_rate) > 0
                          ? parseFloat(dicdata.vip_rate)
                          : 0)
                      ).toFixed(2)
                    }}%*持仓期{{ dicdata.day }}天{{
                      jguo > 0 ? "+增值收益" + jguo + "元" : ""
                    }}{{
                      jhong > 0 ? "+红包金额" + jhong + "元" : ""
                    }}=总股权收益{{ jzhi.toFixed(2) }}+持仓金额{{
                      dicdata.min
                    }}=平仓总计{{ pczj.toFixed(2) }} CNY
                  </p>
                  <p>
                    5.结算时间：由建仓起24小时开始结算，如早上9:00建仓，隔天9:00计算当日回报收益，每个持仓日系统安全结算是返回账户余额，可申请出资或继续参与项目建仓，在第{{
                      dicdata.day
                    }}个持仓日周期结束时，系统将持仓金额返回到您的平台账户余额，可随时申请出资或继续参与项目建仓。
                  </p>
                  <p>
                    6.可投金额：建仓金额封顶{{
                      dicdata.max
                    }}
                    CNY，募集期间未投满时，投资者可反复建仓，限投{{
                      dicdata.mcount
                    }}次
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab :label="$t('m.lc_span6')" title="常见问题">
            <div style="padding: 0 10px">
              <div
                class="product_tags detacon_quxian"
                style="background: #fff; margin-top: 10px"
              >
                <div class="tags_title leftgo">{{ $t("m.lc_span13") }}</div>
                <div :class="q_hide == 1 ? 'ques' : 'ques q_hide'">
                  <div class="ques_title" @click="toggle_ques(1)">
                    <span>{{ $t("m.lc_span14") }}</span>
                    {{ $t("m.lc_span16") }}
                    <img src="../../assets/images/new/xljt.png" alt="" />
                  </div>
                  <div class="ques_answer">
                    <span>{{ $t("m.lc_span15") }}</span>
                    {{ $t("m.lc_span17") }}
                  </div>
                </div>
                <div :class="q_hide == 2 ? 'ques' : 'ques q_hide'">
                  <div class="ques_title" @click="toggle_ques(2)">
                    <span>{{ $t("m.lc_span14") }}</span>
                    {{ $t("m.lc_span18") }}
                    <img src="../../assets/images/new/xljt.png" />
                  </div>
                  <div class="ques_answer">
                    <span>{{ $t("m.lc_span15") }}</span>
                    {{ $t("m.lc_span19") }}
                  </div>
                </div>
                <div
                  :class="q_hide == 3 ? 'ques' : 'ques q_hide'"
                  style="border: none"
                >
                  <div class="ques_title" @click="toggle_ques(3)">
                    <span>{{ $t("m.lc_span14") }}</span>
                    {{ $t("m.lc_span20") }}
                    <img src="../../assets/images/new/xljt.png" />
                  </div>
                  <div class="ques_answer">
                    <span>{{ $t("m.lc_span15") }}</span>
                    {{ $t("m.lc_span21") }}
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <!-- <div class="detacon_quxian" style="margin-top:10px;">
        <p style="text-align:left;" class="">常见问题</p>
        <div>
            <div style="display:flex;align-items:center;">
              <span style="width: 26px;line-height:26px;border-radius:50%;background:#ff1900;">问</span>
              <span style="font">该产品气息、到账规则是什么？</span>
            </div>
        </div>
      </div> -->
      <div style="padding: 0 20px">
        <div class="detacon_xq" v-if="dicdata.status == 2">
          <div
            @click="details(dicdata.id)"
            :style="{
              background: dicdata.status == 2 ? '#dfdfdf' : 'var(--bg-color)'
            }"
            style="
              text-align: center;
              height: 44px;
              line-height: 44px;
              color: #fff;
              font-weight: bold;
            "
          >
            {{ dicdata.status == 2 ? $t("m.lc_span30") : $t("m.jiancang") }}
          </div>
        </div>
        <div style="display: flex; align-items: center" v-else>
          <div
            @click="details(dicdata.id, 0)"
            style="
              flex: 1;
              margin-right: 24px;
              margin-top: 30px;
              border-radius: 8px;
              line-height: 40px;
              text-align: center;
              font-size: 15px;
              font-weight: bold;
              color: #fff;
              background: var(--bg-color);
            "
          >
            {{ $t("m.hz_span10") }}
          </div>
        </div>
      </div>

      <div style="height: 90px; width: 100%"></div>
    </div>
  </div>
</template>
<script>
import request from "@utils/request";
let NAME = "GoodsCon";
export default {
  name: NAME,
  components: {},
  data: function() {
    return {
      q_hide: 1,
      guo: 0,
      hong: 0,
      zhi: 0,
      jzhi: 0,
      shengxia: "",
      image: require("@assets/images/licai/datou.png"),
      images: [
        require("@assets/images/bank/f1.jpg"),
        require("@assets/images/bank/f2.jpg"),
        require("@assets/images/bank/f0.jpg"),
        require("@assets/images/bank/f4.jpg"),
        require("@assets/images/bank/f5.jpg"),
        require("@assets/images/bank/f6.jpg"),
        require("@assets/images/bank/f7.jpg"),
        require("@assets/images/bank/f8.jpg"),
        require("@assets/images/bank/f9.jpg"),
        require("@assets/images/bank/f3.jpg")
      ],
      dicdata: { schedule: 0 },
      shareInfoStatus: false,
      weixinStatus: false,
      mapShow: false,
      mapKey: "",
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      days: "",
      type: null
    };
  },

  watch: {},
  updated() {
    // window.scroll(0, 0);
  },
  mounted: function() {
    var myDate = new Date();
    let yue = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    let ri = myDate.getDate(); //获取当前日(1-31)
    if (yue < 10) {
      yue = "0" + yue;
    }
    if (ri < 10) {
      ri = "0" + ri;
    }
    this.days = yue + "-" + ri;

    let type = this.$route.params.id;
    this.type = type;
    console.log("传参");
    console.log(type);
    this.$nextTick(function() {
      request
        .get("/fund/project/detail", { id: type }, { login: false })
        .then(res => {
          this.dicdata = res.data.data;
          this.shengxia = (
            (parseFloat(this.dicdata.price) * (100 - this.dicdata.schedule)) /
            100
          ).toFixed(0);
          if (this.dicdata.added > 0) {
            this.guo = (
              ((this.dicdata.min * this.dicdata.rate) / 100) *
              this.dicdata.day *
              (this.dicdata.added / 100)
            ).toFixed(2);
            this.jguo = (
              ((this.dicdata.min *
                (
                  parseFloat(this.dicdata.rate) +
                  parseFloat(this.dicdata.vip_rate)
                ).toFixed(2)) /
                100) *
              this.dicdata.day *
              (this.dicdata.added / 100)
            ).toFixed(2);
          }
          if (this.dicdata.gift > 0) {
            this.hong = ((this.dicdata.min * this.dicdata.gift) / 100).toFixed(
              2
            );
            this.jhong = ((this.dicdata.min * this.dicdata.gift) / 100).toFixed(
              2
            );
          }
          this.dicdata.rate = Number(this.dicdata.rate);
          this.zhi =
            parseFloat(
              (
                this.dicdata.min *
                Number(this.dicdata.rate) *
                0.01 *
                this.dicdata.day
              ).toFixed(2)
            ) +
            parseFloat(this.guo || 0) +
            parseFloat(this.hong || 0);
          console.log("-> this.dicdata.rate", this.dicdata.rate);
          console.log("-> this.dicdata.min", this.dicdata.min);
          console.log("-> this.zhi", this.zhi);
          this.jzhi =
            parseFloat(
              (
                this.dicdata.min *
                (
                  parseFloat(this.dicdata.rate) +
                  parseFloat(this.dicdata.vip_rate || 0)
                ).toFixed(2) *
                0.01 *
                this.dicdata.day
              ).toFixed(2)
            ) +
            parseFloat(this.jguo || 0) +
            parseFloat(this.jhong || 0);
          console.log("-> this.jzhi", this.jzhi);
          this.pczj = this.dicdata.min + this.jzhi;
          console.log("-> this.pczj", this.pczj);

          // this.dicdata = res.data.data;
          //   this.dicdata.rateh = (
          //     Number(this.dicdata.rate) + Number(this.dicdata.vip_rate || 0)
          //   ).toFixed(3);
          //   console.log("-> this.dicdata", this.dicdata);
          //   this.dicdata.schedule = Number(this.dicdata.schedule || 0).toFixed(3);
          //   this.shengxia = (
          //     (parseFloat(this.dicdata.price) * (100 - this.dicdata.schedule)) /
          //     100
          //   ).toFixed(0);
          //   if (this.dicdata.additional == 1) {
          //     this.guo = (
          //       (this.dicdata.min *
          //         this.dicdata.rateh *
          //         0.01 *
          //         this.dicdata.day) /
          //       2
          //     ).toFixed(2);
          //     console.log("-> this.guo", this.guo);
          //   }
          //   if (this.dicdata.gift > 0) {
          //     this.hong = ((this.dicdata.min * this.dicdata.gift) / 100).toFixed(
          //       2
          //     );
          //     console.log("-> this.hong", this.hong);
          //   }
          //   this.zhi =
          //     parseFloat(
          //       (
          //         this.dicdata.min *
          //         this.dicdata.rateh *
          //         0.01 *
          //         this.dicdata.day
          //       ).toFixed(2)
          //     ) +
          //     parseFloat(this.guo) +
          //     parseFloat(this.hong);
          //   console.log("-> this.zhi", this.zhi);
          // })
          // .catch(err => {
          //   console.log(err);
        });
    });
  },
  methods: {
    toggle_ques(index) {
      this.q_hide = index;
    },
    details: function(e, t) {
      if (this.dicdata.status == 2) {
        return;
      }
      localStorage.setItem("zhonglei", t);
      this.$router.push({
        path: "/pay/" + e
      });
    },
    fanhui: function() {
      this.$router.go(-1);
    },
    juti: function() {
      this.$router.push({
        path: "/shop/touZiList"
      });
    }
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped lang="less">
/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
/deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/ .van-icon {
  color: #fff;
}
.detacon {
  background-color: #f2f1f6;
}
.detacon_quxian {
  border-radius: 8px;
  padding: 15px;
  background-color: #ffffff;
}
.detacon_quxian img {
  width: 100%;
}
.detacon_xq {
  overflow: hidden;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin-top: 30px;
  border-radius: 8px;
}
.detacon_quxian p {
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000;
  line-height: 20px;
}
.detacon_wai {
  padding: 0 15px;
}
.detacon_con_bot {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.detacon_con_bot_block {
  flex: 1;
}
.detacon_con_bot_block p:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  opacity: 0.5;
  text-align: center;
}
.detacon_con_bot_block p:last-child {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}
.detacon_con {
  background-color: #ffffff;
  padding: 20px 15px;
}
.detacon_con_top {
  display: flex;
  align-items: center;
  padding: 15px;
}
.detacon_con_top_left_tit {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #100d0d;
  line-height: 35px;
}
.detacon_con_top_left_txt {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #100d0d;
  line-height: 35px;
}
.detacon_con_top_right {
  margin-left: auto;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff1900;
  line-height: 36px;
}
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}
.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.productSort_block_left_xh {
  /* max-width: 260px; */

  /* margin-bottom: 5px; */
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.productSort_block_left_dm {
  border: 1px solid red;
  color: red;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 10px;
}
.fengxian1 span {
  border: 0.5px solid var(--bg-color);
  color: var(--bg-color);
  padding: 2px 4px;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 9px;
}
.fengxian12 span {
  color: #fff;
  background: var(--bg-color);
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 12px;
}
.productSort_block_last {
  padding: 0px 9px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.productSort_block_last_item:last-child {
  margin-left: 0px;
}
.productSort_block_left {
  display: flex;
  align-items: center;
  padding-left: 9px;
  margin-bottom: 6px;
}
.productSort_con_list {
  margin-top: -46px;
  padding: 15px 0px;
  background-image: url(../../assets/images/new/gradient-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 175px;
}
.productSort_block {
  position: relative;

  width: 100%;
  background-color: #ffffff;
  padding: 20px 10px;
  margin-bottom: 10px;
}
.productSort_block img {
  width: 100%;
  height: 86px;
}
.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}
.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.productSort_top_blocks {
  border-bottom: 2px solid #ff1900;
  color: #ff1900;
}

.product_tags {
  padding: 30rpx 28rpx;
  display: flex;
  flex-direction: column;
}

.tags_title {
  font-size: 32rpx;
  font-weight: 500;
  margin-bottom: 20rpx;
  color: #333;
  display: flex;
  justify-content: space-around;
}

.tags_title view {
  width: 184rpx;
  height: 45rpx;
  font-family: PingFang;
  font-weight: bold;
  color: #999999;
  text-align: center;
  position: relative;
}

.leftgo {
  justify-content: left;
}

.tag_active {
  color: #ed540b !important;
}

.active_line {
  width: 45rpx !important;
  height: 4rpx !important;
  background: #ed540b;

  position: absolute;
  bottom: -10rpx;
  left: 65rpx;
}

.tags_item_wrap {
  display: flex;
  align-items: center;

  width: 80rpx;
}

.tags_item_wrap.left {
  float: left;
}

.tags_item_wrap.right {
  float: right;
}

.tags_item_wrap image {
  width: 80rpx;
  height: 80rpx;
  margin: 0 auto;
  display: block;
}

.tags_item {
  font-size: 25rpx;
  font-weight: 500;
}

.tags_item_title {
  align-items: center;
  display: flex;
}

.tags_item_title text {
  color: #101422;
  font-size: 18rpx;
  margin-right: 8rpx;
}

.tags_content {
  color: #999999;
  margin-top: 10rpx;
  font-size: 23rpx;
  font-weight: 500;
}

.product_info {
  display: none;
  flex-direction: column;
  font-size: 28rpx;
}

.show {
  display: flex;
}

.info_clomun {
  display: flex;
  line-height: 60rpx;
  border-bottom: #e5e5e5 1rpx solid;
}

.cloumn_title {
  margin-right: 20rpx;
  padding: 15rpx 26rpx;
  width: 16%;
  color: #999999;
}

.cloumn_content {
  padding: 15rpx 28rpx 0;
  text-align: left;
  width: 70%;
}

.cloumn_content_gz {
  padding: 15rpx 26rpx;
  color: rgba(51, 51, 51, 0.7);
  width: 100%;
}

.invest_desc {
  width: 100%;
  height: 185rpx;
  display: none;
}

.shows {
  display: block;
}

.ques {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  border-bottom: 1px solid rgba(51, 51, 51, 0.1);
}

.ques_title {
  color: rgba(51, 51, 51, 1);
  padding: 15px 0;
}

.ques_title span {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: var(--bg-color);
  font-weight: bold;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  margin-right: 13px;
  color: #ffffff;
}

.ques_answer span {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: #fe98b1;
  font-weight: bold;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  margin-right: 13px;
  color: #ffffff;
}

.ques_title img {
  width: 18px;
  height: 15px;
  opacity: 0.6;
  float: right;
  position: relative;
  top: 10px;
  display: none;
}

.ques_answer {
  font-weight: 400;
  color: rgba(51, 51, 51, 0.7);
  border-radius: 50%;
  margin-bottom: 10px;
  position: relative;
  top: -14rpx;
  line-height: 22px;
}

.q_hide .ques_answer {
  display: none;
}

.q_hide img {
  display: block;
}

.bottom_wrap {
  width: 100%;
  font-weight: 400;
  color: #999999;
  font-size: 26rpx;
  background-color: rgb(244, 245, 247);
  padding: 35rpx 0 40rpx;
  padding-left: 20rpx;
  box-sizing: border-box;
}

.buynow {
  width: 90%;
  height: 90rpx;
  color: #ffffff;
  background: linear-gradient(#ef7436, #f96820);
  text-align: center;
  line-height: 90rpx;
  position: fixed;
  left: 50%;
  margin-left: -45%;
  bottom: 20rpx;
  border-radius: 90rpx;
  box-sizing: border-box;
}

.percent_wrap {
  display: flex;
  align-items: center;
  margin-top: 80rpx;
}

.percent_num {
  font-size: 23rpx;
  font-family: PingFang;
  font-weight: 500;
  color: #483311;
}

.content_list_line {
  height: 6rpx;
  background-color: #e9eaee;
  border-radius: 100rpx;
  width: 100%;
}

.content_list_line_bili {
  width: 86%;
  height: 100%;
  background-color: rgb(255, 164, 0);
  border-radius: 100rpx;
  background: #c7a976;
}

.product_ld {
  width: 80%;
  height: 80rpx;
  margin: 0 auto;
}

.list {
  display: flex;
  flex-direction: row;
  height: 120rpx;
  width: 690rpx;
  margin: 0 auto;
  border-radius: 10rpx;
  margin-top: 8rpx;
  margin-bottom: 80rpx;
  position: relative;
  z-index: 1;
}

.list_1 {
  display: flex;
  flex-direction: row;
  height: 100rpx;
  width: 660rpx;
  margin: 0 auto;

  margin-bottom: 0rpx;
  position: relative;
  z-index: 1;
}

.line {
  width: 660rpx;
  height: 1rpx;
  background-color: #e5e5e5;
}

.list_1_left {
  height: 100%;
  line-height: 100rpx;
  color: #999999;
  font-size: 24rpx;
  font-weight: 500;
}

.list_1_right {
  height: 100%;
  line-height: 100rpx;
  padding-left: 80rpx;
  font-size: 24rpx;
  font-weight: 500;
}

.list .list_item {
  flex: 1;
  height: 120rpx;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.list_item_top,
.list_item_bottom {
  text-align: center;
}

.list_item_bottom {
  font-size: 24rpx;
  font-family: PingFangSC;
  font-weight: 500;
  color: #000000;
  margin-top: 10rpx;
}

.list_item_img {
  width: 80rpx;
  height: 80rpx;
}

.ques_title uni-text {
  background: linear-gradient(#ef7436, #f96820);
}

.ques_answer uni-text {
  background: linear-gradient(#4d4a48, #2c2927);
}
::v-deep {
  .van-tabs__line {
    background-color: var(--bg-color);
  }
}
.aaa-dc {
  background: #f5f5f8;
  border-radius: 5px;
  line-height: 35px;
  font-size: 12px;
  margin-top: 10px;
  padding-left: 10px;
}
.desc-sll p {
  font-size: 13px;
  font-family: Microsoft YaHei;
  color: #000;
  line-height: 20px;
  font-weight: 400;
  border-radius: 8px;
  padding: 10px;
  background-color: #f7f7f7;
  margin-bottom: 10px;
}
</style>
